import assistantIconWebp from "@/assets/chatbot/ai-assistant-icon.webp?url";
import assistantIconPng from "@/assets/chatbot/ai-assistant-icon.png?url";

/**
 * Chatbot settings (single source for limits used by UI copy)
 */
/** ~4 chars/token heuristic; server enforces ~800 tokens via admin API */
export const CHATBOT_SETTINGS = {
  maxMessageLength: 3200,
  maxHistoryMessages: 6,
  publicCaptchaAfterInteractions: 2,
} as const;

export const CHATBOT_ASSETS = {
  assistantIconWebp,
  assistantIconPng,
  /** @deprecated Use assistantIconWebp / assistantIconPng with `<picture>` */
  assistantIconUrl: assistantIconWebp,
} as const;

/**
 * Chatbot UI labels and text
 */
export const CHATBOT_LABELS = {
  title: "Ask Voly",
  subtitle: "the AI Assistant",
  welcomeMessage: "Hello! I'm your AI assistant. Ask me anything about the EVoly platform.",
  placeholder: "Ask me anything about managing your organization...",
  disclaimer:
    "AI chatbot powered by AWS. Conversations are recorded for quality control. The AI chatbot can make mistakes. Please double-check responses. The AI is optimised for English. Responses in other languages may be incomplete.",
  limitReachedMessage:
    "You've reached the daily limit for the assistant. Please try again tomorrow.",
  messageLengthError: `Message must be ${CHATBOT_SETTINGS.maxMessageLength} characters or less`,
  captchaRequiredMessage:
    "Please complete CAPTCHA to continue chatting.",
  captchaFailedMessage:
    "CAPTCHA verification failed. Please retry the challenge.",
} as const;
